import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import style from "./NovaSenha.module.css";
import { useState } from "react";
import Logo from "../../assets/logoItera.png";
import RecuperarSenhaApi from "../../services/RecuperarSenhaApi";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import InputNovaSenha from "../../components/inputNovaSenha/InputNovaSenha";

export default function NovaSenha() {
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');
    const [tipoAlerta, setTipoAlerta] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const token = query.get('token');

    async function BotaoRedefinirSenha() {
        if (senha !== confirmarSenha) {
            setMensagemAlerta("As senhas devem ser iguais.");
            setTipoAlerta('danger');
            exibirAlerta();
            return;
        }

        try {
            setLoading(true);
            await RecuperarSenhaApi.redefinirSenhaAsync(token, senha);
            window.location.href = process.env.REACT_APP_SITE_LOGIN;
            setMensagemAlerta("Senha redefinida com sucesso!");
            setTipoAlerta('success');
            exibirAlerta();
        } catch (error) {
            if (error.response && error.response.data) {
                if (error.response.data.includes("Token inválido")) {
                    setMensagemAlerta("O Token informado ja foi usado ou não é valido.");
                } else {
                    setMensagemAlerta(`Erro ao tentar redefinir senha: ${error.response.data}`);
                }
            } else {
                setMensagemAlerta("Erro ao tentar redefinir senha. Por favor, tente novamente mais tarde.");
            }
            setTipoAlerta('danger');
            exibirAlerta();
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className={style.conteudo}>
            <Alerta
                tipo={tipoAlerta}
                mensagem={mensagemAlerta}
                visivel={mostrarAlerta}
                aoFechar={() => setMostrarAlerta(false)}
            />
             {loading && <Loader />}
            <div className={style.conteudo_esquerda}>
                <img src={centroEsquerdo} alt="centroEsquerdo" className={style.centro_esquerdo} />
            </div>
            <div className={style.conteudo_login}>
                <img src={Logo} alt="logo" className={style.imagem_logo} />
                <Form onSubmit={(e) => { e.preventDefault(); BotaoRedefinirSenha(); }}>

                    <Form.Group controlId="formSenha" className="mb-3">
                        <InputNovaSenha id={style.campos} type="password" placeholder="senha" name="senha" value={senha} onChange={(e) => setSenha(e.target.value)} required maxLength={50} />
                    </Form.Group>

                    <Form.Group controlId="formConfirmarSenha" className="mb-3">
                        <Form.Control id={style.campos} type="password" placeholder="confirmar senha" name="confirmarSenha" value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} required maxLength={50}/>
                    </Form.Group>

                    <Button variant="primary" type="submit" id={style.botao_entrar}>
                        Recuperar Senha
                    </Button>
                </Form>
                <Link to="/login" className={style.voltar_login}>Voltar ao Login</Link>
            </div>
            <div className={style.conteudo_direita}>
                <img src={superiorDireito} alt="superiorDireito" className={style.superior_direito} />
                <img src={inferiorDireito} alt="inferiorDireito" className={style.inferior_direito} />
            </div>
        </div>
    );
}